@import "../../theme/tokens";
@import "../../theme/fragment-helpers";

.chroa-category-tree-facet {
  & ul, & li {
    list-style: none;
    appearance: none;
    padding-left: 0;
    margin: 0;
  }

  & label {
    margin-bottom: 0;
  }

  &__list &__item {
    margin-top: $t-sp-16;
  }
  &__list--depth-1 > &__item:first-child {
    margin-top: 0;
  }

  &__top-level-item {
    margin-top: $t-sp-16;

    &:first-child {
      margin-top: 0;
    }

    &--hidden {
      display: none;
    }
  }

  &__item--hidden {
    display: none;
  }

  &__item label:has(input[type="checkbox"]) input[type="checkbox"] {
    margin-right: $t-sp-8;
  }

  &__search {
    display: flex;
    align-items: center;
    gap: $t-sp-8;
    padding: $t-sp-8 $t-sp-16;
    margin-bottom: $t-sp-16;
    border: 1px solid $t-color-border-gray;
    border-radius: 4px;
  }

  &__search-input {
    flex: 1 1 auto;
    min-width: 0;
    border: none;
    outline: none;
    font-size: $t-font-size-base;
    background: transparent;
  }

  &__search-submit {
    display: inline-flex;
    flex: 0 0 auto;
    padding: 0;
    border: none;
    background: transparent;
    color: $t-color-gray-700;
    cursor: pointer;

    &:hover, &:focus-visible {
      color: $t-color-primary;
    }
  }

  // aria-live announcer only — no visible layout footprint.
  &__search-status {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

}

// Hide the whole facet portlet (accordion included) when the category tree
// rendered but has no terms in it — mirrors chroa-category-list-facet's rule.
.portlet-category-facet:has(.chroa-category-tree-facet__list):not(:has(.chroa-category-tree-facet__item)) {
  display: none;
}

.chroa-accordion {
  border-bottom: 1px solid $t-color-border-gray;

  &:last-child {
    border-bottom: none;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $t-sp-16 0;
    margin: 0;
    cursor: pointer;
    list-style: none;

    &::-webkit-details-marker {
      display: none;
    }
  }

  &__title-text {
    margin: 0;
    font-size: $t-font-size-base;
    font-weight: 400;
  }

  &__toggle {
    display: inline-flex;
    flex: 0 0 auto;
    transition: transform 0.2s ease;
  }

  &[open] &__toggle {
    transform: rotate(180deg);
  }

  &__content {
    padding-bottom: $t-sp-16;
  }
}
